import { render, staticRenderFns } from "./actividad-unica-resp.vue?vue&type=template&id=7344e4cd&scoped=true&"
import script from "./actividad-unica-resp.vue?vue&type=script&lang=js&"
export * from "./actividad-unica-resp.vue?vue&type=script&lang=js&"
import style0 from "./actividad-unica-resp.vue?vue&type=style&index=0&id=7344e4cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7344e4cd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!F:/Backup_Juan/ecopetrol/Cursos 2019/hidrocarburos/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VFlex,VIcon,VLayout})
